import { render, staticRenderFns } from "./NewNuestraRed.vue?vue&type=template&id=76411a14&scoped=true"
import script from "./NewNuestraRed.vue?vue&type=script&lang=ts"
export * from "./NewNuestraRed.vue?vue&type=script&lang=ts"
import style0 from "./NewNuestraRed.vue?vue&type=style&index=0&id=76411a14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76411a14",
  null
  
)

export default component.exports